// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"69c4bc42","455":"28feccd9","488":"249b63a4","977":"c455244d"}[chunkId] + ".chunk.js");